import { useState } from "react";
import { ListPicker } from "../../components/generic/ListPicker";
import { SettingItem } from "../../components/orgSettings/SettingsItem";
import { usePickerhook } from "../../hooks/usePickerhook";
import { CiLight } from "react-icons/ci";
import { CiDark } from "react-icons/ci";
import { PiDesktopThin } from "react-icons/pi";
import { Button } from "../../components/forms";
import Switch from "react-switch";
import { BiEdit } from "react-icons/bi";
import { JSX } from "react/jsx-runtime";
import { useStateSetter } from "../../hooks/statehooks/UseStateSettersHook";
import { FaInfo } from "react-icons/fa";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { onGetOtp } from "../../services/auth/user";
 
export default () => {

  const { setShowModal, setVerifyEmail,setLoading } = useStateSetter();
  const {authuser}=useStateGetter()
const navigate=useNavigate()

const [authappcode, setauthappcode] = useState(false);
const [smscode, setsmscode] = useState(true);
const [emailpasscode, setemailpasscode] = useState(false);
const [biometric, setbiometric] = useState(true);
const [mobilepass, setmobilepass] = useState(true);
const [securityquest, setsecurityquest] = useState(true);

const {showModal}=useStateSetter()
  const GetOtpModal = () => {




 return(
    <div className=" flex flex-col justify-center items-center">
      <p className=" font-medium text-textbg  my-2">
        {" "}
        Email Verification required{" "}
      </p>
      <p className="font-light text-textbg  text-xs text-center">
        {" "}
        Your email needs to be verified, we will send a One Time Password (OTP)
        to your email
      </p>
      <div className=" gap-6 w-full flex ">
        <Button
          outlined
          disabled={false}
          text="cancel"
          onBtnClick={() => {
            setShowModal(false);
          }}
        />
        <Button
          disabled={false}
          text="Get OTP"
          onBtnClick={async () => {
            setLoading(true);
            var postdata = { email: authuser.email };
            setVerifyEmail(authuser.email );
            var res = await onGetOtp(postdata);
            setLoading(false);
            toast("OTP sent to your email");
            navigate("/home/settings/verifyemail");
            setShowModal(false);
          }}
        />
      </div>
    </div>)



};

  return (
    <div className="w-full pr-20  flex  ">
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Password and Security
          </p>
        </div>

        <hr />
        <div className="mt-4 flex flex-col gap-2">
          {/* Reset Password  */}

          <div className="border flex  border-gray-300 justify-between p-3 items-center rounded-[8px]">
            <div>
              <p className="text-xl text-textbg font-bold">Reset Password</p>
              <p className="text-xs">
                Click on the button to reset your password
              </p>
            </div>

            <Button
              width={200}
              text={<>Change password</>}
              onBtnClick={() => {


                showModal(
                  "",
                  "",
                  <FaInfo
                    size={40}
                    className="inline text-textbg p-2 rounded-full bg-faint"
                  />,
                  <GetOtpModal />
                );
              }}
            />
          </div>

          {/* Two-Factor Authentication */}
          <div className="mt-2 p-3 border flex  border-gray-300 rounded-[8px] flex-col gap-2 ">
            <div>
              <p className="text-xl text-textbg font-bold">
                Two-Factor Authentication
              </p>
              <p className="text-xs">
                Add an extra layer of security to block unauthorised access and
                protect your account
              </p>
            </div>
            <SettingItem
              subtitle="Enter code generated by your authenticator app to confirm"
              title="Authenticator app code"
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setauthappcode(!authappcode);
                  }}
                  checked={authappcode}
                />
              }
            />

            <SettingItem
              subtitle="SMS code Receive SMS code to Confirm it’s you."
              title=" SMS code"
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setsmscode(!smscode);
                  }}
                  checked={smscode}
                />
              }
            />
            <SettingItem
              subtitle="Email passcode"
              title="Receive Email code to Confirm it’s you."
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setemailpasscode(!emailpasscode);
                  }}
                  checked={emailpasscode}
                />
              }
            />
          </div>

          {/* Multi-Factor Authentication */}
          <div className="mt-2 p-3 border flex  border-gray-300 rounded-[8px] flex-col gap-2 ">
            <div>
              <p className="text-xl text-textbg font-bold">
                Multi-Factor Authentication
              </p>
              <p className="text-xs">
                Add an extra layer of security to block unauthorised access and
                protect your account
              </p>
            </div>
            <SettingItem
              subtitle="Fingerprints, facial recognition, voice recognition."
              title="Biometrics"
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setbiometric(!biometric);
                  }}
                  checked={biometric}
                />
              }
            />

            <SettingItem
              subtitle="fingerprints, facial recognition, voice recognition."
              title="Mobile Password"
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setmobilepass(!mobilepass);
                  }}
                  checked={mobilepass}
                />
              }
            />
            <SettingItem
              subtitle="Receive SMS code to Confirm it’s you."
              title="Security questions"
              action={
                <Switch
                  checkedIcon={false}
                  uncheckedIcon={false}
                  offColor="#EAECF5"
                  onColor="#CB0E5F"
                  className="m-4"
                  onChange={() => {
                    setsecurityquest(!securityquest);
                  }}
                  checked={securityquest}
                />
              }
            />
            {/* Liat out all securiy question with option to edit */}
            <SettingItem
              subtitle="What is the name of your first school?"
              title=""
              action={
                <Button
                  outlined
                  width={500}
                  text={
                    <>
                      <BiEdit className="inline mr-1 " />
                      Edit
                    </>
                  }
                  style={"  bg-transparent"}
                  onBtnClick={() => {}}
                />
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
